import { List, Version } from "../types";
import axios from "axios";

export const getDataApi = async (token: string) => {
  return fetch("/data-lists", {
    method: "GET",
    headers: { Authorization: `Bearer ${token}` },
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error(response.statusText);
      }
      return response.json();
    })
    .then(({ data }) => data)
    .catch((error) => {
      console.error("Error fetching data", error);
    });
};

export const addDataApi = async (
  token: string,
  list: List,
  deviceId: string,
) => {
  try {
    const response = await axios.patch(
      "/data-lists",
      { list, deviceId },
      {
        headers: { Authorization: `Bearer ${token}` },
        validateStatus: (status) => status < 500,
      },
    );
    if (response.status === 409) {
      return response.data;
    }
    return response.data;
  } catch (error: any) {
    console.error("Error updating data", error.message || error);
    throw error;
  }
};

export const updateDataApi = async (
  token: string,
  lists: List[],
  deviceId: string,
) => {
  return fetch("/data-lists", {
    method: "PUT",
    headers: { Authorization: `Bearer ${token}` },
    body: JSON.stringify({ lists, deviceId }),
  })
    .then((response) => {
      if (!response.ok) {
        if (response.status === 409) {
          return response.json();
        } else throw new Error(response.statusText);
      }
      return response.json();
    })
    .then((data) => data)
    .catch((error) => {
      console.error("Error updating data", error.message);
    });
};

export const removeDataApi = async (
  token: string,
  version: Version,
  listId: string,
  deviceId: string,
) => {
  return fetch("/data-lists", {
    method: "DELETE",
    headers: { Authorization: `Bearer ${token}` },
    body: JSON.stringify({ version, listId, deviceId }),
  })
    .then((response) => {
      if (!response.ok) {
        if (response.status === 409) {
          return response.json();
        } else throw new Error(response.statusText);
      }
      return response.json();
    })
    .then((data) => data)
    .catch((error) => {
      console.error("Error updating data", error.message);
    });
};
